import { render, staticRenderFns } from "./InvoiceImportViewPage.vue?vue&type=template&id=252c7ad5&scoped=true&"
import script from "./InvoiceImportViewPage.vue?vue&type=script&lang=ts&"
export * from "./InvoiceImportViewPage.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceImportViewPage.vue?vue&type=style&index=0&id=252c7ad5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c7ad5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VCardText,VCardTitle,VProgressCircular,VSpacer})
